import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Layouts from "../../layouts/layouts";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

export default function UserLiveTracking() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [trackingData, setTrackingData] = useState([]);
  const [userName, setUserName] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalRows, setTotalRows] = useState(0);

  // Function to fetch tracking data
  const fetchTrackingData = async (pageNo = page, limitNo = rowsPerPage) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const params = {
        page: pageNo,
        limit: limitNo,
      };

      if (selectedDate) {
        params.date = selectedDate;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/user-tracking-v2/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        },
      );

      const data = response.data;

      setTrackingData(data.data || []);
      setTotalRows(data.count || 0);

      setUserName(
        data.data?.length > 0 ? data.data[0]?.id_user?.name || "User" : "User",
      );
    } catch (error) {
      console.error("Error fetching user tracking data:", error);
      setTrackingData([]);
    }
  };

  useEffect(() => {
    fetchTrackingData(page, rowsPerPage);
  }, [userId, selectedDate, page, rowsPerPage]);

  // const handleMapNavigation = (coordinates) => {
  //   navigate(`/mymapcomponentuser/${userId}`, {
  //     state: { selectedCoordinates: coordinates },
  //   });
  // };

  const handleMapNavigation = (coordinates, trackingDate) => {
    navigate(`/mymapcomponentuser/${userId}`, {
      state: {
        selectedCoordinates: coordinates,
        selectedDate: trackingDate,
      },
    });
  };

  const columns = [
    {
      name: <b>Date</b>,
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: <b>Longitude</b>,
      selector: (row) => row.tracking_coordinates?.longitude || "N/A",
      sortable: true,
    },
    {
      name: <b>Latitude</b>,
      selector: (row) => row.tracking_coordinates?.latitude || "N/A",
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <button
          className="btn btn-info btn-sm ms-1"
          onClick={() =>
            handleMapNavigation(
              {
                lat: row.tracking_coordinates?.latitude,
                lng: row.tracking_coordinates?.longitude,
              },
              moment(row.createdAt).format("YYYY-MM-DD"),
            )
          }
        >
          <FontAwesomeIcon icon={faMapMarkerAlt} />
        </button>
      ),
    },
  ];

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between align-items-center border-bottom pb-1">
                {userName
                  ? `${userName} - Live Tracking`
                  : "User Live Tracking"}
                <div className="d-flex align-items-center">
                  <div>
                    <label>Select Date:</label>
                    <input
                      type="date"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                      className="form-control"
                      style={{ width: "150px" }}
                    />
                  </div>
                </div>
              </div>
              <div className="card-body">
                <DataTable
                  columns={columns}
                  data={trackingData}
                  pagination
                  fixedHeader
                  highlightOnHover
                  responsive
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={5}
                  paginationRowsPerPageOptions={[5, 10, 15, 20]}
                  onChangePage={(page) => setPage(page)}
                  onChangeRowsPerPage={(newPerPage, page) => {
                    setRowsPerPage(newPerPage);
                    setPage(page);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
